import React, { useEffect, useRef } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import specialtyConfig from './specialtyConfig';

const WITHOUT_SPECIALTY = '__WITHOUT_SPECIALTY__';

function TypeBySpecialty({
    getError = undefined,
    changeField,
    typeBySpecialty,
    typeByPurpose,
    modifiedFields = undefined,
    underStyle = {},
    fromTcOrder = false,
    style = {},
    withoutSpecialtyEnabled = false,
}) {
    const prevTypeByPurpose = useRef(typeByPurpose);

    // reset typeBySpecialty when typeByPurpose changes
    useEffect(() => {
        const hadPurpose = prevTypeByPurpose.current;
        const purposeChanged = hadPurpose && hadPurpose !== typeByPurpose;

        if (
            purposeChanged && 
            typeBySpecialty 
        ) {
            changeField([{ field: 'typeBySpecialty', value: null }]);
        }

        prevTypeByPurpose.current = typeByPurpose;
    }, [typeByPurpose, typeBySpecialty, changeField]);

    const handleChange = (e, index, value) => {
        const fields = [{ field: 'typeBySpecialty', value }];

        // clear linerMeter fields when selecting ro-ro/ro-lo types
        const isRoRoType = /ro-(ro|lo)/i.test(value);
        if (isRoRoType) {
            if (fromTcOrder) {
                fields.push(
                    { field: 'linerMeterMin', value: null },
                    { field: 'linerMeterMax', value: null },
                );
            } else {
                fields.push({ field: 'linerMeter', value: null });
            }
        }

        changeField(fields);
    };

    const specialtyOptions = typeByPurpose
        ? specialtyConfig[typeByPurpose.toLowerCase()] || []
        : [];

    const showUnderline = modifiedFields && modifiedFields.includes('typeBySpecialty');

    return (
        <SelectField
            value={typeBySpecialty}
            disabled={!typeByPurpose}
            onChange={handleChange}
            maxHeight={200}
            name="typeBySpecialty"
            floatingLabelText="Type By Specialty"
            errorText={getError ? getError.typeBySpecialty : ''}
            fullWidth
            autoWidth
            underlineStyle={showUnderline ? underStyle : null}
            style={style}
        >
            <MenuItem value='' primaryText='' />
            {
                withoutSpecialtyEnabled ?
                    <MenuItem
                        value={WITHOUT_SPECIALTY}
                        primaryText="Without Specialty"
                        innerDivStyle={{ fontWeight: 'bold' }}
                    /> : null
            }
            {specialtyOptions.map((specialType, i) => (
                <MenuItem
                    key={`specialType_${i}`}
                    value={specialType}
                    primaryText={specialType}
                />
            ))}
        </SelectField>
    );
}

export default TypeBySpecialty;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TypeBySpecialty.jsx